export const whatsAppUrl = (contact, message) => {
  if (!contact) {
    return null;
  }

  if (!message) {
    return `https://api.whatsapp.com/send?phone=${contact.replace("+", "")}`;
  }

  const encodedMessage = encodeURI(message.trim());
  return `https://api.whatsapp.com/send?phone=${contact}&text=${encodedMessage}`;
};
